export default "__VITE_ASSET__DhaJ$5Oi__"